import { VistaprintAuth } from '@vp/auth-react';
import { Button, Icon, Link } from '@vp/swan';
import React from 'react';

const SignInComponent: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const auth = new (VistaprintAuth.WebAuth as any)();

  const onButtonClick = () => {
    auth.signIn();
  };

  return (
    <>
      <Link
        withIcon
        render={({ children, ...rest }) => (
          <Button skin="link" {...rest}>
            {children}
          </Button>
        )}
        onClick={onButtonClick}
        compactMode
      >
        Sign In <Icon iconType="arrowRight" size="standard" skin="standard" />
      </Link>
    </>
  );
};

export default SignInComponent;
